import React from "react";
import PropTypes from "prop-types";
import "../../../StyleSheet/AppComponent/Buttons/CustomButton.scss";
function CustomButton({
  onClick,
  children,
  type = "button",
  className = "",
  disabled = false,
}) {
  return (
    <button
      className={`custom-button ${className} `}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

CustomButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CustomButton;
